import { Divider } from '@chakra-ui/react'
import { ContentBlock } from 'components/common';
import { useGlobal } from 'src/context'

const GameIntro = ({ content }) => {

  return (
    <div className='mb-6 lg:mb-8'>
      <h4 className='mb-2 pl-2 text-lg leading-none font-bold border-l-4 border-primary'>
        遊戲介紹
      </h4>
      <Divider />

      <div className='bg-white p-4 rounded shadow'>
        <ContentBlock content={content} />
      </div>
    </div>
  )
};

export default GameIntro;